<template>
  <div class="orgs">
    <h1>404</h1>
  </div>
</template>
